import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

// 브라우저 언어 설정을 확인하는 함수
const getInitialLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  // ko, ko-KR 등으로 시작하는 경우 한국어로 설정
  return browserLang.toLowerCase().startsWith('ko') ? 'ko' : 'en';
};

export const translations = {
  ko: {
    title: "오늘도 스도쿠",
    settings: "설정",
    restart: "다시하기",
    share: "공유하기",
    rules: "규칙",
    difficulty: "난이도",
    lives: "기회",
    languageSelect: "언어선택",
    contact: "문의하기",
    close: "닫기",
    difficultyLevels: {
      1: "1. 살랑살랑",
      2: "2. 기분좋게",
      3: "3. 산뜻하게",
      4: "4. 두근두근",
      5: "5. 흥미롭게",
      6: "6. 집중해서",
      7: "7. 진지하게",
      8: "8. 치열하게",
      9: "9. 말리지마"
    },
    bannerDisclaimer: {
      line1: "쿠팡 파트너스 활동의 일환으로,",
      line2: "이에 따른 일정액의 수수료를 제공받습니다."
    },
    modals: {
      confirm: {
        message: "지금까지 진행한 게임이 사라져요.\n정말 괜찮나요?",
        cancel: "안돼요!",
        confirm: "좋아요!"
      },
      rules: {
        title: "스도쿠 규칙",
        description: "아래 2가지 규칙에 맞춰서 모든칸을 채워주세요!",
        rule1: "각각의 가로줄과 세로줄에 1~9가 중복 없이 하나씩 들어가야 해요.",
        rule2: "3×3칸 안에는 1~9가 중복 없이 하나씩 들어가야 해요.",
        confirm: "알겠어요!"
      },
      share: {
        message: "링크가 복사되었어요\n친구에게 추천해주세요!",
        confirm: "좋아요!"
      },
      contact: {
        message: "heokiro@gmail.com\n문의사항은 이메일로 보내주세요",
        confirm: "알겠어요!"
      },
      gameOver: {
        message: "아쉬워요\n기회를 모두 소진했어요",
        confirm: "확인"
      },
      gameClear: {
        1: {
          message: "멋져요! 가볍게 즐기면서 완성했어요!",
          morning: "오늘도 상쾌한 하루 보내세요!",
          evening: "편안한 저녁 되세요!"
        },
        2: {
          message: "좋아요! 기분 좋게 해결했어요!",
          morning: "오늘 하루도 유쾌한 기운이 가득하길!",
          evening: "기분 좋은 하루였기를 바라요!"
        },
        3: {
          message: "산뜻한 해결! 정말 잘했어요!",
          morning: "오늘 하루도 상쾌하게 시작해보세요!",
          evening: "하루 마무리도 상쾌하게!"
        },
        4: {
          message: "두근두근, 성공! 멋진 해결력이에요!",
          morning: "설레는 하루가 되길 바랄게요!",
          evening: "오늘 하루도 의미 있었길 바라요!"
        },
        5: {
          message: "흥미진진! 즐겁게 풀었나요?",
          morning: "하루를 흥미롭게 시작해보세요!",
          evening: "오늘 하루도 즐거운 경험이었길!"
        },
        6: {
          message: "집중해서 완성! 대단해요!",
          morning: "오늘도 몰입하는 하루가 되길!",
          evening: "집중한 만큼 보람찬 하루였길 바라요!"
        },
        7: {
          message: "진지하게 도전, 완벽한 해결!",
          morning: "오늘 하루도 신중하고 멋지게 보내세요!",
          evening: "하루의 노력, 빛이 났어요!"
        },
        8: {
          message: "치열한 승부! 정말 대단해요!",
          morning: "오늘도 끝까지 최선을 다해봐요!",
          evening: "오늘 하루도 최선을 다한 당신, 최고예요!"
        },
        9: {
          message: "말리지마! 극한의 도전을 이겨냈어요!",
          morning: "한계를 넘어선 당신, 오늘도 대단해요!",
          evening: "최고의 승리자! 편안한 밤 보내세요!"
        },
        confirm: "확인",
        nextLevel: "다음 레벨로"
      },
      gameList: {
        message: "게임 목록으로 돌아가시겠습니까?"
      },
      restart: {
        message: "게임을 다시 시작하시겠습니까?"
      }
    },
    buttons: {
      memo: "메모",
      erase: "지우기"
    },
    mainTitle: "Everyday Games",
    games: {
      sudoku: {
        title: "오늘도 스도쿠",
        description: "스도쿠 게임, 다양한 난이도로 즐겨요"
      },
      diamond: {
        title: "보석 키우기",
        description: "보석을 합쳐 큰 보석을 만들어보세요",
        rules: {
          title: "규칙",
          description: "같은 모양의 보석을 합쳐 최종 단계(11단계) 다이아몬드를 만들어보세요!"
        }
      },
      comingSoon: {
        description: "새로운 게임이 곧 출시됩니다."
      },
      "2048": {
        title: "2048",
        description: "숫자를 합쳐 2048을 만들어보세요",
        rules: "방향키버튼이나 WASD로 타일을 움직여 같은 숫자를 합치세요. 2048을 만들면 승리!",
        victory: "축하합니다! 2048을 만들었어요!",
        continueMessage: "계속해서 더 높은 점수에 도전해보세요!",
        keepGoing: "계속하기",
        watchAdContinue: "광고 보고 이어하기",
        adInProgress: "광고 시청 중... %seconds%초",
        adReady: "이어하기 준비 완료!",
        continueGame: "이어하기"
      },
      grape: {
        title: "청포도 10",
        description: "숫자를 합쳐 10을 만들어보세요",
        rules: {
          title: "게임 규칙",
          description: "첫 번째 선택한 숫자와 두번째 선택한 숫자의 영역 안의 숫자들의 합이 10이 되면 득점입니다!\n2분 안에 최고점수에 도달해보세요!"
        },
        gameOver: {
          title: "게임 종료",
          timeUp: "시간이 다 되었습니다!",
          moveTimeUp: "입력 시간 동안 포도를 제거하지 못했습니다!",
          score: "\n최종 점수: %score%점"
        },
        start: "게임 시작",
        score: "점수 ",
        timers: {
          gameTime: "제한시간",
          moveTime: "입력 시간"
        },
        difficulty: {
          free: "자유모드",
          level: "레벨",
          target: "목표",
          input: "입력"
        }
      },
      common: {
        sound: "효과음"
      },
      jump: {
        title: "파닥파닥",
        description: "장애물을 피해 달려보세요",
        rules: {
          title: "게임 규칙",
          description: "스페이스바나 터치로 점프해서 장애물을 피하세요!\n최대한 멀리 달려보세요!"
        }
      },
      speedMath: {
        title: "빠른 산수 챌린지",
        description: "60초 안에 사칙연산을 풀어 점수를 올려요",
        mode: "모드",
        timeLeft: "남은 시간",
        modes: {
          add: "덧셈",
          sub: "뺄셈",
          mul: "곱셈",
          mix: "혼합"
        },
        rules: {
          title: "게임 규칙",
          description: "60초 안에 최대한 많은 문제를 맞혀보세요!\n· 정답: +1점\n· 오답: 시간 -3초\n· 모드 변경 시 게임 재시작"
        }
      },
      wordle: {
        title: "단어추리왕",
        description: "자음과 모음을 추리해 숨은 단어를 맞혀요",
        length: "칸 수",
        lengths: {
          4: "4칸",
          5: "5칸",
          6: "6칸"
        },
        inputHint: "글자를 입력하세요",
        tooShort: "글자를 다 채워주세요",
        notInDict: "사전에 없는 단어예요",
        loadingDict: "사전을 불러오는 중이에요...",
        invalidSeed: "잘못된 시드예요. 새 문제를 냈어요!",
        sharedPuzzle: "공유받은 문제",
        win: "정답이에요!",
        lose: "아쉬워요!",
        answerWas: "정답",
        attempts: "시도",
        shareResult: "결과 공유",
        copied: "결과를 복사했어요!",
        linkCopied: "링크를 복사했어요!",
        copyFailed: "복사에 실패했어요. 직접 복사해주세요!",
        createPuzzle: "문제 내기",
        createHint: "친구에게 낼 정답 단어를 입력하세요.\n시드가 담긴 링크를 보내면 이 단어로 게임할 수 있어요.",
        createPlaceholder: "예) 사랑",
        createLength: "{n}칸 문제예요",
        createOutOfRange: "4~6칸 단어만 낼 수 있어요",
        createNotHangul: "한글 단어를 입력해주세요",
        seedLabel: "시드",
        copyLink: "링크 복사",
        closeModal: "창닫기",
        newPuzzle: "새 문제 풀기",
        rules: {
          title: "게임 규칙",
          description: "숨은 단어를 6번 안에 맞혀보세요!\n\n단어는 자음과 모음으로 나눠서 한 칸씩 입력해요.\n예) 사랑 → ㅅ ㅏ ㄹ ㅏ ㅇ (5칸)\n\n· 초록: 자리까지 정확해요\n· 노랑: 단어에 있지만 자리가 달라요\n· 회색: 단어에 없어요\n\n사전에 있는 단어만 시도할 수 있어요.\n'문제 내기'로 직접 낸 문제를 친구에게 공유해보세요!"
        }
      }
    },
    gameList: "게임목록",
    score: "점수",
    gameOver: "게임 오버",
    finalScore: "최종 점수",
    playAgain: "다시 하기",
    gameClear: "Game Clear!",
    nextLevel: "다음 레벨로",
    patchNotes: "패치노트",
  },
  en: {
    title: "Daily Sudoku",
    settings: "Settings",
    restart: "Restart",
    share: "Share",
    rules: "Rules",
    difficulty: "Level",
    lives: "Lives",
    languageSelect: "Language",
    contact: "Contact",
    close: "Close",
    difficultyLevels: {
      1: "1.Breeze",
      2: "2.Cheer",
      3: "3.Fresh",
      4: "4.Excite",
      5: "5.Curious",
      6: "6.Focus",
      7: "7.Serious",
      8: "8.Intense",
      9: "9.Rampage"
    },
    bannerDisclaimer: {
      line1: "As part of Coupang Partners' activities,",
      line2: "we receive a small commission for purchases made."
    },
    modals: {
      confirm: {
        message: "Current game progress will be lost.\nAre you sure?",
        cancel: "No!",
        confirm: "Yes!"
      },
      rules: {
        title: "Sudoku Rules",
        description: "Fill in all cells following these 2 rules!",
        rule1: "Each row and column must contain numbers 1-9 without repetition.",
        rule2: "Each 3×3 box must contain numbers 1-9 without repetition.",
        confirm: "Got it!"
      },
      share: {
        message: "Link copied!\nShare with your friends!",
        confirm: "OK!"
      },
      contact: {
        message: "heokiro@gmail.com\nPlease send your inquiries to email",
        confirm: "OK!"
      },
      gameOver: {
        message: "Game Over\nYou've used all your chances",
        confirm: "OK"
      },
      gameClear: {
        1: {
          message: "Great job! You completed it with ease!",
          morning: "Wishing you a refreshing day ahead!",
          evening: "Have a relaxing evening!"
        },
        2: {
          message: "Nice! That was a smooth solve!",
          morning: "May your day be filled with joy!",
          evening: "Hope you had a delightful day!"
        },
        3: {
          message: "That was a crisp and clean solve! Well done!",
          morning: "Start your day feeling fresh and energized!",
          evening: "End your day on a refreshing note!"
        },
        4: {
          message: "Exciting! You did an amazing job!",
          morning: "Hope your day is filled with excitement!",
          evening: "Hope today was meaningful for you!"
        },
        5: {
          message: "Thrilling! Did you enjoy solving it?",
          morning: "Start your day with curiosity and excitement!",
          evening: "Hope today was a fun and exciting experience!"
        },
        6: {
          message: "Focused and completed! Well done!",
          morning: "Wishing you a productive and immersive day!",
          evening: "A rewarding day for your dedication!"
        },
        7: {
          message: "A serious challenge, perfectly solved!",
          morning: "Stay sharp and have a great day ahead!",
          evening: "Your hard work shines today!"
        },
        8: {
          message: "A fierce challenge! Truly impressive!",
          morning: "Give it your all and make today count!",
          evening: "You gave it your best—you're amazing!"
        },
        9: {
          message: "Unstoppable! You conquered the ultimate challenge!",
          morning: "You've pushed your limits—have a fantastic day!",
          evening: "A true champion! Enjoy a well-earned rest!"
        },
        confirm: "OK",
        nextLevel: "Next Level"
      },
      gameList: {
        message: "Do you want to return to the game list?"
      },
      restart: {
        message: "Do you want to restart the game?"
      }
    },
    buttons: {
      memo: "Memo",
      erase: "Erase"
    },
    mainTitle: "Everyday Games",
    games: {
      sudoku: {
        title: "Daily Sudoku",
        description: "Enjoy Sudoku With 9 Levels"
      },
      diamond: {
        title: "Raising gems",
        description: "Merge gems to create bigger ones",
        rules: {
          title: "Rules",
          description: "Merge identical gems to create the final stage (Level 11) diamond!"
        }
      },
      comingSoon: {
        description: "New game coming soon."
      },
      "2048": {
        title: "2048",
        description: "Merge numbers to create 2048",
        rules: "Use arrow keys or WASD to move tiles. Merge same numbers to create 2048 and win!",
        victory: "Congratulations! You've reached 2048!",
        continueMessage: "Keep playing to achieve a higher score!",
        keepGoing: "Keep going",
        watchAdContinue: "Watch Ad to Continue",
        adInProgress: "Watching ad... %seconds%s",
        adReady: "Ready to continue!",
        continueGame: "Continue"
      },
      grape: {
        title: "Grape 10",
        description: "Merge numbers to create 10",
        rules: {
          title: "Game Rules",
          description: "Score points by selecting an area where the sum of numbers equals 10!\nTry to reach the highest score within 2 minutes!"
        },
        gameOver: {
          title: "Game Over",
          timeUp: "Time's up!",
          moveTimeUp: "Failed to remove grapes within input times!",
          score: "\nFinal Score: %score%"
        },
        start: "Start Game",
        score: "Score ",
        timers: {
          gameTime: "Time Limit",
          moveTime: "Input Time"
        },
        difficulty: {
          free: "Free Mode",
          level: "Level",
          target: "Target",
          input: "Input"
        }
      },
      common: {
        sound: "Sound"
      },
      jump: {
        title: "FlapFlap",
        description: "Run as far as you can while avoiding obstacles",
        rules: {
          title: "Game Rules",
          description: "Jump using spacebar or touch to avoid obstacles!\nTry to run as far as possible!"
        }
      },
      speedMath: {
        title: "Speed Math",
        description: "Solve as many arithmetic problems as you can in 60 seconds",
        mode: "Mode",
        timeLeft: "Time Left",
        modes: {
          add: "Addition",
          sub: "Subtraction",
          mul: "Multiplication",
          mix: "Mixed"
        },
        rules: {
          title: "Game Rules",
          description: "Solve as many problems as you can within 60 seconds!\n· Correct: +1 point\n· Wrong: -3 seconds\n· Mode change restarts the game"
        }
      },
      wordle: {
        title: "Word Master",
        description: "Guess the hidden Korean word letter by letter",
        length: "Length",
        lengths: {
          4: "4 tiles",
          5: "5 tiles",
          6: "6 tiles"
        },
        inputHint: "Type your guess",
        tooShort: "Not enough letters",
        notInDict: "Not in word list",
        loadingDict: "Loading dictionary...",
        invalidSeed: "Invalid seed. Starting a new puzzle!",
        sharedPuzzle: "Shared puzzle",
        win: "You got it!",
        lose: "So close!",
        answerWas: "Answer",
        attempts: "Attempts",
        shareResult: "Share Result",
        copied: "Result copied!",
        linkCopied: "Link copied!",
        copyFailed: "Copy failed. Please copy it manually!",
        createPuzzle: "Create",
        createHint: "Enter the answer word for your friend.\nShare the seed link and they can play your puzzle.",
        createPlaceholder: "e.g. 사랑",
        createLength: "{n}-tile puzzle",
        createOutOfRange: "Only 4-6 tile words are allowed",
        createNotHangul: "Please enter a Korean word",
        seedLabel: "Seed",
        copyLink: "Copy Link",
        closeModal: "Close",
        newPuzzle: "New Puzzle",
        rules: {
          title: "Game Rules",
          description: "Guess the hidden word within 6 tries!\n\nKorean words are split into consonants and vowels, one per tile.\ne.g. 사랑 → ㅅ ㅏ ㄹ ㅏ ㅇ (5 tiles)\n\n· Green: right letter, right spot\n· Yellow: in the word, wrong spot\n· Gray: not in the word\n\nOnly words in the dictionary can be submitted.\nUse 'Create' to make your own puzzle and share it!"
        }
      }
    },
    gameList: "Games",
    score: "Score",
    gameOver: "Game Over",
    finalScore: "Final Score",
    playAgain: "Play Again",
    gameClear: "Game Clear!",
    nextLevel: "Next Level",
    patchNotes: "Patch Notes",
  }
};

export const LanguageProvider = ({ children }) => {
  // 초기 언어 설정을 getInitialLanguage() 함수로 결정
  const [language, setLanguage] = useState(getInitialLanguage());
  
  const value = {
    language,
    setLanguage,
    t: (key) => {
      const keys = key.split('.');
      let result = translations[language];
      for (const k of keys) {
        result = result[k];
      }
      return result;
    }
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}; 